import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import {forkJoin as observableForkJoin,  timer ,  Observable } from 'rxjs';
import { mergeMap, retryWhen } from "rxjs/operators";

import * as dto from "../models/dashboard.dto";
import { SubHeader } from "../../core/models/sub-header.model";

import { DashboardService } from "../services/dashboard.service";
import { SubHeaderService } from "../../core/services/sub-header.service";
import { Dashboard } from "../models/dashboard.dto";
import { genId } from "../../core/services/genId";
import { DashboardType } from "./dashboard-type.enum";
import { LoaderService } from "../../common/services/loader.service";
import { PermissionsService } from "../../admin/services/permissions.service";
import { GroupService, GroupSearchSpec } from "../../admin/services/group.service";
import { AuthService } from "../../services/auth.service";
import { LunaClaimTypes, LunaClaimValues } from "../../models/user-identity.model";
import { Group } from "../../admin/models/group.model";
import { Claim } from "../../admin/models/claim.model";

@Component({
    selector: "create-dashboard",
    templateUrl: "./create-dashboard.component.html",
    styleUrls: ["./create-dashboard.component.scss"],
    standalone: false
})
export class CreateDashboardComponent implements OnInit {
    public subHeader: SubHeader = new SubHeader({ title: "New Page", buttons: [{ name: "Save Page", method: () => this.create() }] });

    public dashboards: Array<Dashboard> = [];
    public dashboardTypes: any = DashboardType;

    public selectedLayout: DashboardType;
    public types: any;
    public layouts: any;
    public copyExistingID: any;

    public dashboard: dto.Dashboard = {} as Dashboard;
    public selectedWidgetType: dto.WidgetKind;
    public selectedLayoutType: dto.DashboardLayoutKind;
    public type: string;
    public formSubmitted: boolean = false;
    public layoutInvalid: boolean = false;

    public moduleInfo: any;

    layoutOptions: Array<any> = [
        {
            value: DashboardType.Single,
            name: "Single View Layout"
        },
        {
            value: DashboardType.Column,
            name: "Column Layout"
        },
        {
            value: DashboardType.Copy,
            name: "Copy Existing"
        }
    ];

    layoutKind: Array<any> = [
        {
            value: dto.DashboardLayoutKind.TwoColumnLeftLarge,
            icon: "icon-three-one",
            selected: false
        }, {
            value: dto.DashboardLayoutKind.TwoColumnEqual,
            icon: "icon-two-two",
            selected: false
        }, {
            value: dto.DashboardLayoutKind.TwoColumnRightLarge,
            icon: "icon-one-three",
            selected: false
        }, {
            value: dto.DashboardLayoutKind.ThreeColumn,
            icon: "icon-one-one-one",
            selected: false
        }
    ];

    //reference to form
    @ViewChild("newDashboard", { static: true }) form: any;

    constructor(
        public dashboardService: DashboardService,
        public subHeaderService: SubHeaderService,
        public router: Router,
        public route: ActivatedRoute,
        public loaderService: LoaderService,
        public _groupService: GroupService,
        public _authService: AuthService
    ) {
        this.moduleInfo = route.snapshot.data.dashboard;
    }

    ngOnInit() {
        //update subheader with title and update button
        this.subHeaderService.updateSubHeader(this.subHeader);

        //get list of dashboards for copying a dashboard
        this.dashboardService.getAll().subscribe(results => {
            this.dashboards = results;
        });

        this.types = Object.keys(dto.WidgetKind);
        this.layouts = Object.keys(dto.DashboardLayoutKind).filter(k => typeof dto.DashboardLayoutKind[k] === "number") as string[];

        //update dashboard id
        this.dashboard.id = genId();

        this.selectedLayout = DashboardType.Single;
    }

    create() {
        this.formSubmitted = true;

        if (this.form.valid) {
            this.loaderService.toggleLoader(true);

            let newDashboard: Dashboard = this.dashboard;
            //if copying dashboard, call copy dashboard function
            if (this.selectedLayout === DashboardType.Copy)
                newDashboard = this.copyExistingDashboard(this.copyExistingID);
            else if (this.selectedLayout === DashboardType.Single) {
                newDashboard.layout = dto.DashboardLayoutKind.SingleColumn;
                newDashboard.columns = [
                    [{
                        component: this.selectedWidgetType
                    }]
                ];
            }
            else if (this.selectedLayout === DashboardType.Column) {
                newDashboard.layout = <dto.DashboardLayoutKind>this.selectedLayoutType;

                switch (this.selectedLayoutType) {
                    case 1:
                    case 2:
                    case 3:
                        newDashboard.columns = [[], []];
                        break;
                    case 4:
                        newDashboard.columns = [[], [], []];
                        break;
                }
            }

            newDashboard.urlPart = "view/";
            newDashboard.id = genId();

            this.dashboardService.post(newDashboard, this.moduleInfo ? this.moduleInfo.moduleGroupId : null, this.moduleInfo ? this.moduleInfo.moduleId : null).subscribe(success => {
                this.loaderService.toggleLoader(true);
                let groups = this._authService.User.groups;
                let obs: Observable<any>[] = [];
                let claim = new Claim();
                claim.type = LunaClaimTypes.Dashboard;
                claim.value = newDashboard.id;

                groups.forEach(groupId => {
                    obs.push(this._groupService.get({ id: groupId } as GroupSearchSpec).pipe(mergeMap((group: Group) => {
                        if (!group.permissions.find(x => x.type === claim.type && x.value === claim.value))
                            group.permissions.push(claim);

                        return this._groupService.save(group).pipe(retryWhen(err => timer(1000)));
                    })));
                });

                observableForkJoin(obs).subscribe((result) => {
                    //route to new dashboard
                    this._authService.User.allClaims.push(claim);
                    this._authService.User.dashboards.push(newDashboard.id);
                    this.loaderService.toggleLoader(false);
                    this.router.navigate(['/dashboard/view', newDashboard.id]);
                }, (error) => { console.error("a request failed") });
            },
                error => {
                    console.error(error);
                    this.loaderService.toggleLoader(false);
                });
        }
    }

    public copyExistingDashboard(id) {
        //get existing dashboard data
        let selectedDashboard = this.dashboards.find(x => x.id === id);

        //update title
        selectedDashboard.title = this.dashboard.title;

        //filter returns array
        return selectedDashboard;
    }
}
